<template>
  <div data-v-92268d78="" id="modalRegister" tabindex="-1" aria-labelledby="modalLabel-register" aria-hidden="true"
    data-modal="modal" class="modal x-modal -v2">
    <div class=" modal-dialog modal-dialog-centered">
      <div class="contentmodal animate__animated animate__bounceInDown modal-content -modal-content">
        <div class="modal-body -modal-body">
          <button type="button" class="close f-1 -in-tab" data-bs-dismiss="modal" aria-label="Close">
            <i class="fas fa-times"></i>
          </button>
          <div class="x-modal-account-security-tabs -v2">
            <button type="button" class="-btn -register js-modal-account-security-tab-button " data-bs-toggle="modal"
              data-bs-target="#modalRegister">สมัครสมาชิก</button>
            <button type="button" class="-btn -login js-modal-account-security-tab-button -active"
              data-bs-toggle="modal" data-bs-target="#modalLogin">เข้าสู่ระบบ
            </button>
          </div>
          <div class="x-modal-separator-container x-login-form">
            <div data-v-92268d78="" v-if="ReqStep == 1" id="comp-wrap-register">
              <div class="mb-1">
                <label for="register-f-phone" class="form-label">
                  กรอกเบอร์มือถือของคุณ
                </label>
                <div class="phone-1st-step">
                  <div class="">
                    <input type="tel" id="register-f-phone" placeholder="เบอร์โทรศัพท์" aria-label="register-f-phone"
                      v-model="PhoneNumber" class="form-control" />
                    <div class="d-block w-100 p-1">
                      <small v-if="PhoneNumber == ''" class="text-danger">
                        กรุณากรอกข้อมูล
                      </small>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mb-3 text-center">
                <button @click="Register()" type="button" class="btn btn-primary -submit">
                  <!---->
                  <span style="color: rgb(255, 255, 255)">ถัดไป</span>
                </button>
              </div>
              <div class="mb-3 d-flex justify-content-center">
                <a style="cursor: pointer !important" data-bs-toggle="modal" data-bs-target="#modalLogin"><small
                    for="f-password" class="form-label">
                    หากคุณมีบัญชีผู้ใช้แล้ว เข้าสู่ระบบ
                  </small></a>
              </div>
            </div>
            <div data-v-92268d78="" v-if="ReqStep == 2" id="comp-wrap-register">
              <div class="mb-0">
                <div>
                  <div class="mb-0">
                    <label class="form-label">เลือกธนาคาร</label>
                    <div class="">
                      <select v-model="BankCode" placeholder="เลือกธนาคารของคุณ" class="form-select">
                        <option selected="selected" value="-1">
                          กรุณาเลือกธนาคาร
                        </option>
                        <option v-for="(item, i) in nameBankArrayList" :key="i" :value="item.id">
                          {{ item.value }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="d-block w-100 p-1">
                  <small v-if="BankCode == '-1'" class="text-danger">
                    กรุณาเลือกธนาคาร
                  </small>
                </div>
              </div>
              <div class="mb-0">
                <label for="f-banknumber" class="form-label">กรอกเลขบัญชีธนาคาร</label>
                <div class="">

                  <input v-model="BankNumber" type="tel" id="f-banknumber" placeholder="กรอกเลขบัญชี"
                    aria-label="f-banknumber" class="form-control" />
                  <div class="d-block w-100 p-1">
                    <small v-if="BankNumber == ''" class="text-danger">
                      กรุณากรอกเลขบัญชี
                    </small>
                  </div>
                </div>
                <!---->
              </div>
              <div class="mb-3 text-center">
                <button @click="Register()" type="button" class="btn btn-primary -submit">

                  <!---->
                  <span style="color: rgb(255, 255, 255)">ถัดไป</span>
                </button>
              </div>
              <div class="mb-3 d-flex justify-content-center">
                <a style="cursor: pointer !important" data-bs-toggle="modal" data-bs-target="#modalLogin"><small
                    for="f-password" class="form-label">
                    หากคุณมีบัญชีผู้ใช้แล้ว เข้าสู่ระบบ
                  </small></a>
              </div>
            </div>

            <div data-v-92268d78="" v-if="ReqStep == 3" id="comp-wrap-register">
              <div class="mb-1">
                <label for="register-f-phone" class="form-label">
                  กรอกเบอร์มือถือของคุณ
                </label>
                <div class="phone-1st-step">
                  <div class="">
                    <input type="tel" id="register-f-phone" placeholder="เบอร์โทรศัพท์" aria-label="register-f-phone"
                      class="form-control" v-model="PhoneNumber" readonly />
                  </div>
                </div>
                <div class="d-block w-100 p-1"></div>
              </div>

              <div class="mb-1">
                <label for="register-f-password" class="form-label">ตั้งรหัสผ่าน</label>
                <div class="">

                  <input :type="showPassRegister == false ? 'password' : 'text'" id="register-f-password"
                    placeholder="ตั้งรหัสผ่าน" aria-label="register-f-password" v-model="Password"
                    class="form-control" />

                  <div class="d-block w-100 p-1">
                    <small v-if="Password == ''" class="text-danger">
                      กรุณากรอกข้อมูล
                    </small>
                  </div>
                </div>
              </div>
              <div class="mb-0">
                <div>
                  <div class="mb-0">
                    <label class="form-label">เลือกธนาคาร</label>
                    <div class="">

                      <select v-model="BankCode" placeholder="เลือกธนาคารของคุณ" disabled="disabled"
                        class="form-select">
                        <option selected="selected" disabled="disabled" value="-1">
                          กรุณาเลือกธนาคาร
                        </option>
                        <option v-for="(item, i) in nameBankArrayList" :key="i" :value="item.id">
                          {{ item.value }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="d-block w-100 p-1"></div>
              </div>
              <div class="mb-0">
                <label for="f-banknumber" class="form-label">กรอกเลขบัญชีธนาคาร</label>
                <div class="">

                  <input type="tel" id="f-banknumber" placeholder="กรอกเลขบัญชี" aria-label="f-banknumber" readonly
                    v-model="BankNumber" class="form-control" />
                </div>
                <!---->
                <div class="d-block w-100 p-1"></div>
              </div>

              <div class="mb-0">
                <label for="f-banknumber" class="form-label">ชื่อ</label>
                <div class="">

                  <input type="tel" id="f-banknumber" placeholder="ชื่อ" aria-label="f-banknumber"
                    :disabled="tokenBank != ''" v-model="FirstName" class="form-control" />
                </div>
                <!---->
                <div class="d-block w-100 p-1"></div>
              </div>
              <div class="mb-0">
                <label for="f-banknumber" class="form-label">นามสกุล</label>
                <div class=" ">

                  <input type="tel" id="f-banknumber" placeholder="นามสกุล" aria-label="f-banknumber"
                    :disabled="tokenBank != ''" v-model="LastName" class="form-control" />
                </div>
                <div class="d-block w-100 p-1"></div>
                <!---->
              </div>
              <div class="mb-0">
                <label for="f-banknumber" class="form-label">รหัสแนะนำ</label>
                <div class="">

                  <input type="tel" id="f-banknumber" placeholder="รหัสแนะนำ" aria-label="f-banknumber"
                    v-model="shareToken" class="form-control" />
                </div>
                <!---->
                <div class="d-block w-100 p-1"></div>
              </div>
              <div class="mb-0">
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="flexRadioDefault" v-model="isBonus" :value="true"
                    id="flexRadioDefault1" />
                  <label class="form-check-label" for="flexRadioDefault1">
                    รับโปรโมชั่น
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" v-model="isBonus" :value="false" name="flexRadioDefault"
                    id="flexRadioDefault2" checked />
                  <label class="form-check-label" for="flexRadioDefault2">
                    ไม่รับโปรโมชั่น
                  </label>
                </div>
                <div class="d-block w-100 p-1"></div>
              </div>
              <div class="mb-3 text-center">
                <button @click="Register()" type="button" class="btn btn-primary -submit">

                  <!---->
                  <span style="color: rgb(255, 255, 255)">สมัครสมาชิก</span>
                </button>
              </div>
              <div class="mb-3 d-flex justify-content-center">
                <a style="cursor: pointer !important" data-bs-toggle="modal" data-bs-target="#modalLogin"><small
                    for="f-password" class="form-label">
                    หากคุณมีบัญชีผู้ใช้แล้ว เข้าสู่ระบบ
                  </small></a>
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { nameBankArray } from '@/services/modules/Bank.services.js'
import { nameBankArrayList } from '@/config/Bank.js'
import { mapMutations, mapActions, mapGetters } from 'vuex'
import { checkPhoneNumber, checkBankNumber } from '@/services/modules/user.js'

export default {
  name: 'RegisterForm',
  data() {
    return {
      // register
      PhoneNumber: '',
      Password: '',
      ConfirmPassword: '',
      BankCode: '-1',
      BankNumber: '',
      FirstName: '',
      LastName: '',
      SignupToken: '',
      step: 1,
      login: false,
      shareToken: this.$route.params.shareToken,
      isBonus: false,
      tokenBank: '',
      Confirm_Password: '',
      showPassRegisterConfirm: '',
      showPassRegister: false,
      nameBankArrayList: nameBankArrayList,
      ReqStep: 1,
      Partner: '',
    }
  },
  computed: {
    ...mapGetters([
      'getError',
      'getLoading',
      'getLineId',
      'getGameList',
      'getPromotion',
    ]),
  },
  methods: {
    ...mapMutations(['setLoading', 'setLineId']),
    ...mapActions(['userSignIn', 'setError', 'userSignUp']),
    async Register() {
      this.setError(null)
      if (this.ReqStep == 1) {
        return this.Step1checkPhoneNumber()
      } else if (this.ReqStep == 2) {
        return this.Step2checkBankNumber()
      } else {
        let registerDATA = {
          phoneNumber: this.PhoneNumber,
          Password: this.Password,
          Confirm_Password: this.Password,
          BankAccount: this.BankNumber,
          BankCode: this.BankCode,
          firstName: this.FirstName,
          lastName: this.LastName,
          tokenBank: this.tokenBank,
          affiliateKey: this.shareToken,
          isBonus: this.isBonus,
        }
        await this.userSignUp(registerDATA)
        if (this.getError) {
          return this.$swal.fire(this.getError, '', 'error')
        } else {
          return this.$swal.fire('ลงทะเบียนเรียบร้อยแล้ว', '', 'success')
        }
      }
    },

    async Step1checkPhoneNumber() {
      if (this.PhoneNumber.length != 10)
        return this.$swal.fire(
          'หมายเลขโทรศัพท์ ไม่ถูกต้อง กรุณากรอกใหม่',
          '',
          'error'
        )
      if (this.PhoneNumber == '' || this.PhoneNumber.length != 10) {
        return this.$swal.fire(
          'หมายเลขโทรศัพท์ ไม่ถูกต้อง กรุณากรอกใหม่',
          '',
          'error'
        )
      }
      await checkPhoneNumber(this.PhoneNumber, (res) => {
        if (res.status) {
          this.ReqStep = 2
          this.setError(null)
        } else {
          return this.$swal.fire(res.message, '', 'error')
        }
      })
    },
    async Step2checkBankNumber() {
      if (
        this.BankCode == '-1' ||
        (this.BankNumber.length != 10 && this.BankNumber.length != 12)
      ) {
        // return this.setError('กรุณากรอกข้อมูลก่อนยืนยัน')
        return this.$swal.fire('กรุณากรอกข้อมูลก่อนยืนยัน', '', 'error')
      }

      await checkBankNumber(this.BankNumber, this.BankCode, (res) => {
        if (res.status) {
          if (res.data) {
            if (res.data.firstName != undefined) {
              this.FirstName = res.data.firstName
            }
            if (res.data.lastName != undefined) {
              this.LastName = res.data.lastName
            }
            if (res.data.token != undefined) {
              this.tokenBank = res.data.token
            }
          }
          this.ReqStep = 3
          this.setError(null)
        } else {
          return this.$swal.fire(res.message, '', 'error')
        }
      })
    },
  },
  async mounted() {
    if (this.shareToken != undefined) {
      localStorage.setItem('shareToken', this.shareToken)
    } else {
      if (this.shareToken == undefined) {
        if (localStorage.getItem('shareToken')) {
          this.shareToken = localStorage.getItem('shareToken')
        }
      }
    }
  },
}
</script>

<style scoped>
.form-check-input[type=checkbox] {
  width: 1em;
  border-radius: 0.25em;
}

.form-check-input[type=radio] {
  width: 1em;
  border-radius: 1em;
}
</style>




// WEBPACK FOOTER //
// src/components/form/RegisterForm.vue